//Loadable插件需使用Loading
import Loadable from 'react-loadable'
import Loading from '../components/Loading/index';

export const routerRoot = [
   
    // {
    //     title: "办事大厅首页",
    //     path: "/",
    //     name: Loadable({
    //         loader: () => import('../views/Home'),
    //         loading: Loading
    //     })
    // },
    {
        title: "科技工作者首页",
        path: "/:mao?",
        name: Loadable({
            loader: () => import('../views/HomeKjgzz'),
            loading: Loading
        })
    },
    {
        title: "搜索列表",
        path: "/searchList/:typename/:search",
        name: Loadable({
            loader: () => import('../views/ListSearch'),
            loading: Loading
        })
    },
  
    // {
    //     title: "多余二级列表",
    //     path: "/HomeList/:typename",
    //     name: Loadable({
    //         loader: () => import('../views/HomeList'),
    //         loading: Loading
    //     })
    // },
    {
        title: "会议活动",
        path: "/active/:typename",
        name: Loadable({
            loader: () => import('../views/ListActive'),
            loading: Loading
        })
    },
    {
        title: "活动详情",
        path: "/DetailActive/:typename/:id",
        name: Loadable({
            loader: () => import('../views/DetailActive'),
            loading: Loading
        })
    },
    {
        title: "人物列表",
        path: "/ListRw/:typename",
        name: Loadable({
            loader: () => import('../views/ListRw'),
            loading: Loading
        })
    },
    {
        title: "人物列表",
        path: "/ListRw2/:typename",
        name: Loadable({
            loader: () => import('../views/ListRw2'),
            loading: Loading
        })
    },
    {
        title: "湖北省科普先进工作者",
        path: "/NewsListTab/:typename",
        name: Loadable({
            loader: () => import('../views/NewsListTab'),
            loading: Loading
        })
    },
    {
        title: "中国青年科技奖",
        path: "/NewsListTabYoung/:typename",
        name: Loadable({
            loader: () => import('../views/NewsListTabYoung'),
            loading: Loading
        })
    },
    {
        title: "中国青年女科学家奖",
        path: "/NewsListTabScience/:typename",
        name: Loadable({
            loader: () => import('../views/NewsListTabScience'),
            loading: Loading
        })
    },
    {
        title: "求是杰出青年奖",
        path: "/NewsListTabOutstanding/:typename",
        name: Loadable({
            loader: () => import('../views/NewsListTabOutstanding'),
            loading: Loading
        })
    },
    {
        title: "国家卓越工程师奖",
        path: "/NewsListTabEngineer/:typename",
        name: Loadable({
            loader: () => import('../views/NewsListTabEngineer'),
            loading: Loading
        })
    },
    {
        title: "院士风采",
        path: "/yuanshiRw/:typename",
        name: Loadable({
            loader: () => import('../views/yuanshiRw'),
            loading: Loading
        })
    },
    {
        title: "学会列表",
        path: "/ListXh/:typename",
        name: Loadable({
            loader: () => import('../views/ListXh'),
            loading: Loading
        })
    },
    {
        title: "新闻列表",
        path: "/newsList/:typename",
        name: Loadable({
            loader: () => import('../views/List'),
            loading: Loading
        })
    },
    {
        title: "建言献策",
        path: "/sendMessage/:typename",
        name: Loadable({
            loader: () => import('../views/SendMessage'),
            loading: Loading
        })
    },
    {
        title: "图文列表",
        path: "/listTw/:typename",
        name: Loadable({
            loader: () => import('../views/ListTw'),
            loading: Loading
        })
    },
    {
        title: "外链列表",
        path: "/listLink/:typename",
        name: Loadable({
            loader: () => import('../views/ListLink'),
            loading: Loading 
        })
    },
    {
        title: "图片列表",
        path: "/imgList/:typename",
        name: Loadable({
            loader: () => import('../views/imgList'),
            loading: Loading 
        })
    },
    {
        title: "新闻详情",
        path: "/newsDetail/:typename/:id",
        name: Loadable({
            loader: () => import('../views/Detail'),
            loading: Loading
        })
    },
    {
        title: "人物详情",
        path: "/DetailRw/:typename/:id",
        name: Loadable({
            loader: () => import('../views/DetailRw'),
            loading: Loading
        })
    },
    {
        title: "人物详情2",
        path: "/DetailRw2/:typename/:id",
        name: Loadable({
            loader: () => import('../views/DetailRw2'),
            loading: Loading
        })
    },

  


 
 
    
   
 

];
